var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1707 12C18.1707 11.816 18.1625 11.64 18.1461 11.456L19.6764 10.328C20.0055 10.088 20.096 9.64 19.8903 9.288L18.3518 6.704C18.1461 6.352 17.7018 6.208 17.3233 6.368L15.5543 7.096C15.2499 6.888 14.929 6.704 14.5917 6.552L14.3531 4.704C14.3037 4.304 13.95 4 13.5386 4H10.4697C10.05 4 9.69626 4.304 9.64689 4.704L9.40829 6.552C9.07095 6.704 8.75007 6.888 8.44565 7.096L6.6767 6.368C6.29823 6.208 5.85394 6.352 5.64825 6.704L4.10967 9.296C3.90398 9.648 3.99449 10.088 4.32359 10.336L5.85394 11.464C5.83748 11.64 5.82925 11.816 5.82925 12C5.82925 12.184 5.83748 12.36 5.85394 12.544L4.32359 13.672C3.99449 13.912 3.90398 14.36 4.10967 14.712L5.64825 17.296C5.85394 17.648 6.29823 17.792 6.6767 17.632L8.44565 16.904C8.75007 17.112 9.07095 17.296 9.40829 17.448L9.64689 19.296C9.69626 19.696 10.05 20 10.4614 20H13.5303C13.9417 20 14.2955 19.696 14.3449 19.296L14.5835 17.448C14.9208 17.296 15.2417 17.112 15.5461 16.904L17.3151 17.632C17.6935 17.792 18.1378 17.648 18.3435 17.296L19.8821 14.712C20.0878 14.36 19.9973 13.92 19.6682 13.672L18.1378 12.544C18.1625 12.36 18.1707 12.184 18.1707 12ZM12.0329 14.8C10.445 14.8 9.15323 13.544 9.15323 12C9.15323 10.456 10.445 9.2 12.0329 9.2C13.6209 9.2 14.9126 10.456 14.9126 12C14.9126 13.544 13.6209 14.8 12.0329 14.8Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.70e56f37a0f26a688d5fa694e33fd87f.svg";
export { ForwardRef as ReactComponent };